import { useLocation } from 'react-router-dom';
import { capitalize } from '../../settings';

export const SUB_1ST_GRADE_SLUGS = [
  'test-sub1stgrade-tag',
  'pre-k-and-k-playground',
  'playground',
  'games',
  'books',
  'videos',
  'math-zone',
  'planetary-pinball',
  'music-memorizer',
  'water-bug',
  'digging-for-worms',
  'the-piano-player',
  'brain-break',
  'extreme-air',
  'entrapment',
  'fly-trap',
  'space-hopper',
  'color-creature',
  'burned-out',
  'rockin-rabbit',
  'buried-memories',
  'sudoku',
  'fun-match-game',
  'roly-poly-rodeo',
  'double-hooked',
  'swarm',
  'croc-cannon',
  'when-pigs-fly',
  'frost-bite',
  'log-run',
  'mighty-guy',
  'star-climber',
  'turtle-wax',
  'helipopper',
  'swing-fling',
  'oddball',
  'dare-to-be-square',
  'creepy-crawlers',
  'desert-dive',
  'coyote-concentration',
  'penguin-drop',
  'prairie-puzzle',
  'switch',
  'pig-pile',
  'vine-time',
  'simon-sees',
  'treasure-dive',
  'mighty-guy-2',
  'pickle-pop',
  'tinybop-schools-mammals',
  'bunny-count',
  'one-false-move',
  'whats-the-word',
  'cake-monster',
  'apple-catch',
  'number-stampede',
  'soccer-shootout',
  'tic-tac-toe-squares',
  'monster-math-adventure',
  'math-baseball-two-player',
  'math-baseball-spanish-version',
  'math-baseball',
  'shape-invasion',
  'bumble-numbers',
  'connect-the-dots',
  'cut-it',
  'rock-the-boat',
  'chicken-blast',
];

const sizesBySlot = {
  bgo: {
    slotSize: [300, 250],
  },
  top: {
    sizeMapping: [
      { viewport: [0, 0], slot: [320, 50] },
      {
        viewport: [784, 0],
        slot: [
          [728, 90],
          [970, 250],
          [970, 90],
        ],
      },
    ],
  },
  topMobile: {
    slotSize: [320, 50],
  },
  topDesktop: {
    slotSize: [
      [728, 90],
      [970, 250],
      [970, 90],
    ],
  },
  siderec: {
    slotSize: [300, 250],
  },
  sideflex: {
    slotSize: [
      [300, 600],
      [300, 250],
    ],
  },
  outofpage: {
    slotSize: [1, 1],
  },
};

const targetingBySlot = slot => {
  switch (slot) {
    case 'top':
    case 'siderec':
    case 'bgo':
      return { pos: ['ATF'] };
    case 'sideflex':
      return { pos: ['BTF'] };
    default:
      return null;
  }
};

const adIdByPageType = {
  HP: {
    topDesktop: 'div-gpt-ad-1527599876437-0',
    topMobile: 'div-gpt-ad-1527628860838-0',
    siderec: 'div-gpt-ad-1527600665601-0',
    sideflex: 'div-gpt-ad-1527600455255-0',
  },
  playground: {
    topDesktop: 'div-gpt-ad-1527601398242-0',
    topMobile: 'div-gpt-ad-1527629763598-0',
    siderec: 'div-gpt-ad-1527605617601-0',
    sideflex: 'div-gpt-ad-1527605494034-0',
  },
  '1stgrade': {
    topDesktop: 'div-gpt-ad-1527601621696-0',
    topMobile: 'div-gpt-ad-1527629000643-0',
    siderec: 'div-gpt-ad-1527605709610-0',
    sideflex: 'div-gpt-ad-1527603765589-0',
  },
  '2ndgrade': {
    topDesktop: 'div-gpt-ad-1527601772756-0',
    topMobile: 'div-gpt-ad-1527629108230-0',
    siderec: 'div-gpt-ad-1527605794854-0',
    sideflex: 'div-gpt-ad-1527603907908-0',
  },
  '3rdgrade': {
    topDesktop: 'div-gpt-ad-1527601947069-0',
    topMobile: 'div-gpt-ad-1527629200921-0',
    siderec: 'div-gpt-ad-1527605883534-0',
    sideflex: 'div-gpt-ad-1527604109979-0',
  },
  '4thgrade': {
    topDesktop: 'div-gpt-ad-1527602026238-0',
    topMobile: 'div-gpt-ad-1527629266627-0',
    siderec: 'div-gpt-ad-1527606017504-0',
    sideflex: 'div-gpt-ad-1527604212262-0',
  },
  '5thgrade': {
    topDesktop: 'div-gpt-ad-1527602276688-0',
    topMobile: 'div-gpt-ad-1527629333763-0',
    siderec: 'div-gpt-ad-1527606089624-0',
    sideflex: 'div-gpt-ad-1527604335354-0',
  },
  '6thgrade': {
    topDesktop: 'div-gpt-ad-1527602383287-0',
    topMobile: 'div-gpt-ad-1527629405003-0',
    siderec: 'div-gpt-ad-1527606188396-0',
    sideflex: 'div-gpt-ad-1527604422827-0',
  },
  '7thgrade': {
    topDesktop: 'div-gpt-ad-1527602468623-0',
    topMobile: 'div-gpt-ad-1527629477896-0',
    siderec: 'div-gpt-ad-1527606277310-0',
    sideflex: 'div-gpt-ad-1527604626171-0',
  },
  '8thgrade': {
    topDesktop: 'div-gpt-ad-1527602558809-0',
    topMobile: 'div-gpt-ad-1527629561276-0',
    siderec: 'div-gpt-ad-1527606342739-0',
    sideflex: 'div-gpt-ad-1527604723333-0',
  },
  video: {
    topDesktop: 'div-gpt-ad-1527602685380-0',
    topMobile: 'div-gpt-ad-1527629846286-0',
    siderec: 'div-gpt-ad-1527606422157-0',
    sideflex: 'div-gpt-ad-1527604821637-0',
  },
  games: {
    topDesktop: 'div-gpt-ad-1527602832501-0',
    topMobile: 'div-gpt-ad-1527629700284-0',
    siderec: 'div-gpt-ad-1527606519507-0',
    sideflex: 'div-gpt-ad-1527604992441-0',
  },
  books: {
    topDesktop: 'div-gpt-ad-1527602967096-0',
    topMobile: 'div-gpt-ad-1527629625888-0',
    siderec: 'div-gpt-ad-1527606599163-0',
    sideflex: 'div-gpt-ad-1527605074382-0',
  },
  teachersandparents: {
    topDesktop: 'div-gpt-ad-1527603122625-0',
    topMobile: 'div-gpt-ad-1527629924790-0',
    siderec: 'div-gpt-ad-1527606665292-0',
    sideflex: 'div-gpt-ad-1527605235698-0',
  },
  ROS: {
    topDesktop: 'div-gpt-ad-1527608136013-0',
    topMobile: 'div-gpt-ad-1527629998990-0',
    siderec: 'div-gpt-ad-1527608389416-0',
    sideflex: 'div-gpt-ad-1527608291222-0',
  },
  math: {
    topDesktop: 'div-gpt-ad-1527603273183-0',
    topMobile: 'div-gpt-ad-1527630106097-0',
    siderec: 'div-gpt-ad-1527606864076-0',
    sideflex: 'div-gpt-ad-1527605388807-0',
  },
};

export const getSlug = pathname => {
  let slug;
  switch (pathname) {
    case '/':
      slug = 'HP';
      break;
    case '/games':
    case '/games/':
      slug = 'games';
      break;
    case '/videos':
    case '/videos/':
      slug = 'video';
      break;
    case '/books':
    case '/books/':
      slug = 'books';
      break;
    case '/grade/1':
    case '/grade/1/':
      slug = '1stgrade';
      break;
    case '/grade/2':
    case '/grade/2/':
      slug = '2ndgrade';
      break;
    case '/grade/3':
    case '/grade/3/':
      slug = '3rdgrade';
      break;
    case '/grade/4':
    case '/grade/4/':
      slug = '4thgrade';
      break;
    case '/grade/5':
    case '/grade/5/':
      slug = '5thgrade';
      break;
    case '/grade/6':
    case '/grade/6/':
      slug = '6thgrade';
      break;
    case '/grade/7':
    case '/grade/7/':
      slug = '7thgrade';
      break;
    case '/grade/8':
    case '/grade/8/':
      slug = '8thgrade';
      break;
    case '/teachers-and-parents':
    case '/teachers-and-parents/':
      slug = 'teachersandparents';
      break;
    case '/playground':
    case '/playground/':
    case '/pre-k-and-k-playground':
    case '/pre-k-and-k-playground/':
      slug = 'playground';
      break;
    case '/math-zone':
    case '/math-zone/':
      slug = 'math';
      break;
    default:
      slug = 'ROS';
  }

  if (pathname.match('videos')) slug = 'video';
  if (pathname.match('games')) slug = 'games';
  if (pathname.match('books')) slug = 'books';

  return slug;
};

const getPathBySlug = (slug, slotName, viewportSize) => {
  const rectangleBase =
    '/96780239/1022050/69783/1022050-69783-medium_rectangle';
  const leaderboardBase = `/96780239/1022050/69783/1022050-69783-${viewportSize}_leaderboard`;
  const rectanglePlus = `${rectangleBase}/1022050-69783-medium_rectangle-CP/1022050-69783-medium_rectangle-CP-//`;
  const leaderboardPlus = `${leaderboardBase}/1022050-69783-${viewportSize}_leaderboard-CP/1022050-69783-${viewportSize}_leaderboard-CP-//`;
  switch (slug) {
    case 'HP':
      if (slotName === 'top') {
        return `${leaderboardBase}/1022050-69783-${viewportSize}_leaderboard-HP`;
      } else {
        return `${rectangleBase}/1022050-69783-medium_rectangle-HP`;
      }
    case 'ROS':
      if (slotName === 'top') {
        return leaderboardBase;
      } else {
        return rectangleBase;
      }
    default:
      return `${slotName === 'top' ? leaderboardPlus : rectanglePlus}${slug}`;
  }
};

export const getAdByLocation = (props, viewportSize) => {
  const location = useLocation();
  const { specialPath, slotName, adUnitPath, id } = props;
  const adData = {};
  const pathname = specialPath ? specialPath : location.pathname;
  const sizedSlot =
    slotName === 'top' ? slotName + capitalize(viewportSize) : slotName;
  const slug = getSlug(pathname);
  adData['id'] = id || adIdByPageType[slug][sizedSlot];
  adData['adUnitPath'] = adUnitPath
    ? adUnitPath
    : getPathBySlug(slug, slotName, viewportSize);
  adData['targeting'] = targetingBySlot(slotName);

  const style = {
    flex: '0 0 auto',
    maxWidth: slotName === 'sideflex' ? '312px' : 'none',
    margin: '0 auto',
    backgroundColor: 'rgba(255,255,255,.5)',
    padding: '5px',
  };

  return {
    ...adData,
    ...sizesBySlot[sizedSlot],
    style,
  };
};
